import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';
import { marked } from 'marked';

@Directive({
  standalone: true,
  selector: '[appSafeHtml]'
})
export class SafeHtmlDirective implements OnChanges {
  @Input('appSafeHtml') htmlContent: string = '';

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(): void {
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', '');

    if (this.htmlContent) {
      const html = marked.parse(this.htmlContent);
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', html);
      this.renderer.setStyle(this.el.nativeElement, 'lineHeight', '27px');
     
    }

this.renderer.addClass(this.el.nativeElement, 'markdown-container');  }
  
}
